import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import React, { FC } from 'react'
import { Button } from 'react-bootstrap'

interface StripeCheckoutFormProps {
  handlePaymentMethodId: (id: string) => void
  paymentMethodId: string
}

export const StripeCheckoutForm: FC<StripeCheckoutFormProps> = ({
  handlePaymentMethodId,
  paymentMethodId,
}) => {
  const stripe = useStripe()
  const elements = useElements()

  const submitPayment = async () => {
    if (!stripe || !elements) {
      return
    }

    const cardElement = elements.getElement(CardElement)

    if (cardElement) {
      const { paymentMethod } = await stripe.createPaymentMethod({
        card: cardElement,
        type: 'card',
      })

      if (paymentMethod) {
        handlePaymentMethodId(paymentMethod.id)
      } else {
        handlePaymentMethodId('')
      }
    }
  }

  return (
    <>
      <CardElement
        options={{
          style: {
            base: {
              '::placeholder': {
                color: '#aab7c4',
              },
              color: '#424770',
              fontSize: '16px',
            },
            invalid: {
              color: '#9e2146',
            },
          },
        }}
      />
      {!paymentMethodId && (
        <Button onClick={submitPayment} disabled={!stripe}>
          Add Card
        </Button>
      )}
    </>
  )
}
